module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-b27f7f5a.png";